import { LicensesComponent } from './shared/components/licenses/licenses.component';
import { ConfigResolver } from './core/resolvers/config.resolver';
import { NgModule, importProvidersFrom } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AccountsListComponent } from './shared/modules/accounts/accounts-list/accounts-list.component';
import { RouteProxyComponent } from './shared/components/route-proxy/route-proxy.component';
import { GlobalErrorComponent, LogoutComponent, OktaCustomCallbackComponent, UserGuard } from 'ccc-commons/core';
import { FullWidthComponent } from './shared/containers/full-width/full-width.component';
import { OKTA_CONFIG } from '@okta/okta-angular';
import { OktaAuthModule,  } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { OktaConfig } from '../environments/environment';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'organization/root'
  },
  {
    path: 'organization/root',
    loadChildren: () => import('./ccc-organization/ccc-organization.module').then(m => m.CccOrganizationModule),
    canActivate: [ UserGuard ],
    resolve: { config: ConfigResolver },
  },
  {
    path: 'organization',
    loadChildren: () => import('./organization/organization.module').then(m => m.OrganizationModule),
    canActivate: [ UserGuard ],
    resolve: { config: ConfigResolver },
  },
  {
    path: '',
    component: FullWidthComponent,
    canActivate: [ UserGuard ],
    resolve: { config: ConfigResolver },
    children: [
      {
        path: 'settings',
        outlet: 'modal',
        component: RouteProxyComponent,
        children: [
          {
            path: '',
            loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule),
          },
        ],
      },
      {
        path: 'accounts',
        component: AccountsListComponent,
      },
      {
        path: 'licenses',
        component: LicensesComponent,
      }
    ]
  },
  {
    path: 'account-error',
    component: GlobalErrorComponent,
  },
  {
    path: 'implicit/callback',
    component: OktaCustomCallbackComponent
  },
  {
    path: 'implicit/code',
    component: OktaCustomCallbackComponent
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: 'login',
    component: OktaCustomCallbackComponent,
  },
  { path: '**', redirectTo: 'organization/root', pathMatch: 'full' },

];



@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    OktaAuthModule.forRoot({oktaAuth: new OktaAuth(OktaConfig)})
  ],
  exports: [RouterModule],
  providers: [
    { provide: OKTA_CONFIG, useValue: new OktaAuth(OktaConfig) },
    UserGuard,
    ConfigResolver
  ]
})
export class AppRoutingModule { }
